import {
  FETCH_ACCOUNT_SEMI_TRAILER_INIT,
  FETCH_ACCOUNT_SEMI_TRAILER_SUCCESS,
  FETCH_ACCOUNT_SEMI_TRAILER_FAILURE,
  FETCH_ACCOUNT_SEMI_TRAILER_EXTENDED_PROPERTIES_INIT,
  FETCH_ACCOUNT_SEMI_TRAILER_EXTENDED_PROPERTIES_SUCCESS,
  FETCH_ACCOUNT_SEMI_TRAILER_EXTENDED_PROPERTIES_FAILURE,
  FETCH_ACCOUNT_SEMI_TRAILER_COUNT_INIT,
  FETCH_ACCOUNT_SEMI_TRAILER_COUNT_SUCCESS,
  FETCH_ACCOUNT_SEMI_TRAILER_COUNT_FAILURE,
  FETCH_ACCOUNT_SEMI_TRAILER_NO_LOADING_INIT,
  FETCH_ACCOUNT_SEMI_TRAILER_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_SEMI_TRAILER_NO_LOADING_FAILURE,
  SAVE_ACCOUNT_SEMI_TRAILER_INIT,
  SAVE_ACCOUNT_SEMI_TRAILER_SUCCESS,
  SAVE_ACCOUNT_SEMI_TRAILER_FAILURE,
  UPDATE_ACCOUNT_SEMI_TRAILER_INIT,
  UPDATE_ACCOUNT_SEMI_TRAILER_SUCCESS,
  UPDATE_ACCOUNT_SEMI_TRAILER_FAILURE,
  DELETE_ACCOUNT_SEMI_TRAILER_INIT,
  DELETE_ACCOUNT_SEMI_TRAILER_SUCCESS,
  DELETE_ACCOUNT_SEMI_TRAILER_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_SEMI_TRAILER,
  FETCH_DOWNLOAD_ACCOUNT_SEMI_TRAILER_SUCCESS,
  FETCH_DOWNLOAD_ACCOUNT_SEMI_TRAILER_FAILURE,
  FETCH_DOWNLOAD_ACCOUNT_SEMI_TRAILER_INIT,
  FETCH_UPLOAD_ACCOUNT_SEMI_TRAILER_SUCCESS,
  FETCH_UPLOAD_ACCOUNT_SEMI_TRAILER_FAILURE,
  FETCH_UPLOAD_ACCOUNT_SEMI_TRAILER_INIT,
  RESET_MODAL_FILE,
  ACTIVE_ACCOUNT_SEMI_TRAILER_INIT,
  ACTIVE_ACCOUNT_SEMI_TRAILER_SUCCESS,
  ACTIVE_ACCOUNT_SEMI_TRAILER_FAILURE,
} from './types';
import API from './api';

/* Actions Creators */
export function resetModalFileSemiTrailerAccount() {
  return {
    type: RESET_MODAL_FILE,
  };
}

export function resetModalSemiTrailer() {
  return {
    type: RESET_MODAL,
  };
}

export function resetAccountSemiTrailer() {
  return {
    type: RESET_ACCOUNT_SEMI_TRAILER,
  };
}

/* Account SemiTrailer */

function fetchApiSuccess(data) {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function fetchApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_FAILURE,
    payload: error,
  };
}

function fetchApiInit() {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function fetchAccountSemiTrailerApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Account SemiTrailer no loading */

function fetchApiNoLoadingSuccess(data,concat) {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  console.log(error)
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_NO_LOADING_FAILURE,
    payload: error,
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_NO_LOADING_INIT,
  };
}

export function fetchAccountSemiTrailerNoLoadingApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* SemiTrailer Save (Async) */

function saveApiSuccess(data) {
  return {
    type: SAVE_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function saveApiFailure(error) {
  return {
    type: SAVE_ACCOUNT_SEMI_TRAILER_FAILURE,
    errorSave: error,
  };
}

function saveApiInit() {
  return {
    type: SAVE_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function handleSemiTrailer(data) {
  return async (dispatch) => {
    dispatch(saveApiInit());
    try {
      const resp = await API.data.handleSemiTrailer(data);
      return dispatch(saveApiSuccess(resp));
    } catch (error) {
      return dispatch(saveApiFailure(error));
    }
  };
}

/* SemiTrailer Update (Async) */

function updateApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function updateApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_SEMI_TRAILER_FAILURE,
    errorupdate: error,
  };
}

function updateApiInit() {
  return {
    type: UPDATE_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function handleUpdateSemiTrailer(data) {
  return async (dispatch) => {
    dispatch(updateApiInit());
    try {
      const resp = await API.data.handleUpdateSemiTrailer(data);
      return dispatch(updateApiSuccess(resp));
    } catch (error) {
      return dispatch(updateApiFailure(error));
    }
  };
}


/* SemiTrailer Delete (Async) */

function deleteApiSuccess(data) {
  console.log(data)
  return {
    type: DELETE_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function deleteApiFailure(error) {
  return {
    type: DELETE_ACCOUNT_SEMI_TRAILER_FAILURE,
    errordelete: error,
  };
}

function deleteApiInit() {
  return {
    type: DELETE_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function handleDeleteSemiTrailer(data) {
  return async (dispatch) => {
    dispatch(deleteApiInit());
    try {
      const resp = await API.data.handleDeleteSemiTrailer(data);
      return dispatch(deleteApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteApiFailure(error));
    }
  };
}

/* Account SemiTrailer EXTENDED PROPERTIES */

function fetchApiExtendedPropertiesSuccess(data) {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_EXTENDED_PROPERTIES_SUCCESS,
    payload: data
  };
}

function fetchApiExtendedPropertiesFailure(error) {
  console.log(error);
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_EXTENDED_PROPERTIES_FAILURE,
    payload: error
  };
}

function fetchApiExtendedPropertiesInit() {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_EXTENDED_PROPERTIES_INIT
  };
}

export function fetchAccountSemiTrailerExtendedPropertiesApi(obj) {
  return async dispatch => {
    dispatch(fetchApiExtendedPropertiesInit());
    try {
      let data = await API.data.getExtendedProperties(obj);
      dispatch(fetchApiExtendedPropertiesSuccess(data));
    } catch (error) {
      dispatch(fetchApiExtendedPropertiesFailure(error));
    }
  };
}

/* Account SemiTrailer COUNT */

function fetchApiCountSuccess(data) {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_COUNT_SUCCESS,
    payload: data,
  };
}

function fetchApiCountFailure(error) {
  console.log(error)
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_COUNT_FAILURE,
    payload: error,
  };
}

function fetchApiCountInit() {
  return {
    type: FETCH_ACCOUNT_SEMI_TRAILER_COUNT_INIT,
  };
}

export function fetchAccountSemiTrailerCountApi(obj) {
  return async (dispatch) => {
    dispatch(fetchApiCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiCountFailure(error));
    }
  };
}

/* get download file */

function fetchDownloadApiSuccess(data) {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function fetchDownloadApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_SEMI_TRAILER_FAILURE,
    payload: error,
  };
}

function fetchDownloadApiInit() {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function fetchAccountSemiTrailerDownloadApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchDownloadApiInit());
    try {
      let data = await API.data.handleSemiTrailerDownload(group, tags);
      dispatch(fetchDownloadApiSuccess(data));
    } catch (error) {
      dispatch(fetchDownloadApiFailure(error));
    }
  };
}

/* get download file */

function fetchUploadApiSuccess(data) {
  return {
    type: FETCH_UPLOAD_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function fetchUploadApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_UPLOAD_ACCOUNT_SEMI_TRAILER_FAILURE,
    payload: error,
  };
}

function fetchUploadApiInit() {
  return {
    type: FETCH_UPLOAD_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function fetchAccountSemiTrailerUploadApi(group,tags) {
  return async (dispatch) => {
    dispatch(fetchUploadApiInit());
    try {
      let data = await API.data.handleSemiTrailerUpload(group, tags);
      dispatch(fetchUploadApiSuccess(data));
    } catch (error) {
      dispatch(fetchUploadApiFailure(error));
    }
  };
}

/* Active SemiTrailer (Async) */

function activeApiSuccess(data) {
  return {
    type: ACTIVE_ACCOUNT_SEMI_TRAILER_SUCCESS,
    payload: data,
  };
}

function activeApiFailure(error) {
  return {
    type: ACTIVE_ACCOUNT_SEMI_TRAILER_FAILURE,
    errordelete: error,
  };
}

function activeApiInit() {
  return {
    type: ACTIVE_ACCOUNT_SEMI_TRAILER_INIT,
  };
}

export function handleActiveSemiTrailer(data) {
  return async (dispatch) => {
    dispatch(activeApiInit());
    try {
      const resp = await API.data.handleActiveSemiTrailer(data);
      return dispatch(activeApiSuccess(resp));
    } catch (error) {
      return dispatch(activeApiFailure(error));
    }
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/account_semi_trailer/index.js